import { domain } from 'modules/data';
import { NetSuiteApplyListLineExpanded } from 'shared/states';

export const getNetSuiteBillPaymentBillApplyListAttachments = (
    request: domain.Request | null,
    applyList: NetSuiteApplyListLineExpanded[],
    billRequestId: string
) => {
    if (!request || request.details.integrationCode !== domain.IntegrationCode.NetSuiteBillPayment) {
        return [];
    }

    return (applyList.length ? applyList : request.details.applyList).reduce((attachments, applyListItem) => {
        if (applyListItem.requestId !== billRequestId) {
            return attachments;
        }

        return applyListItem.attachments?.length ? [...attachments, ...applyListItem.attachments] : attachments;
    }, []);
};
